<div class="title"><span class="bold">Prospects </span>becoming<span class="bold"> Active Stores</span></div>
<div class="prospects">
    <div class="prospect" *ngFor="let prospect of prospects">
        <div class="text">{{prospect.name}}</div>
        <img *ngIf="prospect.success" src="/assets/img/game/tick-large.svg">
        <img *ngIf="!prospect.success" src="/assets/img/game/cross-large.svg">
    </div>
</div>